import { useEffect } from "react"
import { embedDashboard } from "@superset-ui/embedded-sdk"
import "./App.css"

function App() {

  const queryParams = new URLSearchParams(window.location.search)
  const dashboard_id = queryParams.get("dashboard_id")
  const token_id = queryParams.get("token_id")
  const unidade_id = queryParams.get("unidade_id")


  const getToken = async () => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    };
 
    var url = dashboard_id + '/' + token_id 
    
    if (unidade_id != null) {
      if (!(unidade_id.trim().length === 0)) {
        url = url + '/' + unidade_id
      }
    }
    const response = await fetch("https://api.hom.edat.unicamp.br/superset/fetchPrivateAccessGuestToken/" + url , requestOptions)
    const token = await response.json()
    return token['token']
  }

  useEffect(() => {
    const embed = async () => {
      await embedDashboard({
        id: dashboard_id, // given by the Superset embedding UI
        supersetDomain: "https://indicadores.hom.edat.unicamp.br",
        mountPoint: document.getElementById("dashboard"), // html element in which iframe render
        fetchGuestToken: () => getToken(),
        dashboardUiConfig: {
          locale: "pt_BR",
          hideTitle: true,
          hideChartControls: false,
          hideTab: true,
          filters: { "expanded": true, "visible": true }
        },
      })
    }
    if (document.getElementById("dashboard")) {
      const iframeSuperset = document.getElementById("dashboard").children[0];
      if (iframeSuperset) {
          iframeSuperset.width = "100%";
          iframeSuperset.height = "100vh";
      }
      embed()
    }
  }, [])

  return (
    <div>
      <div id="dashboard" />
    </div>
  )
}

export default App
